const STRIPE_SUB_ID_KEY = 'dg_stripe_subscription_id';

export function getStoredStripeSubscriptionId(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(STRIPE_SUB_ID_KEY);
  } catch {
    return null;
  }
}

export function setStoredStripeSubscriptionId(id: string | null): void {
  if (typeof window === 'undefined') return;
  try {
    if (id && id.startsWith('sub_')) localStorage.setItem(STRIPE_SUB_ID_KEY, id);
    else localStorage.removeItem(STRIPE_SUB_ID_KEY);
  } catch {
    /* ignore */
  }
}
